export const SEUIL_ENCAISSE = 0.2;
export const SEUIL_ENCAISSE_NUMERAIRE = 0.2;

export const PROTOCOLE_IMPAYE_PES_ASAP = 'Titrage individuel (PES ASAP)';
export const PROTOCOLE_IMPAYE_ORMC = 'Rôle (ORMC)';

export const COMPTABILITE_JVS = 'JVS - Comptabilité';
export const COMPTABILITE_BL = 'BL - BL GF';
export const COMPTABILITE_ODYSSEE = 'ODYSSEE - Comptabilité';
export const COMPTABILITE_CIRIL = 'CIRIL - Civil Finances';
export const COMPTABILITE_COSOLUCE = 'COSOLUCE - Corail';

export const COMPTABILITES = [
  COMPTABILITE_JVS,
  COMPTABILITE_BL,
  COMPTABILITE_ODYSSEE,
  COMPTABILITE_CIRIL,
  COMPTABILITE_COSOLUCE,
];

export const TITRE_RECU_IMPRIME_RECU = 'Reçu';
export const TITRE_RECU_IMPRIME_QUITTANCE = 'Quittance';
export const TITRE_RECU_IMPRIME_ATTESTATION = 'Attestation de paiement';

export const TITRES_RECU_IMPRIME = [
  TITRE_RECU_IMPRIME_RECU,
  TITRE_RECU_IMPRIME_QUITTANCE,
  TITRE_RECU_IMPRIME_ATTESTATION,
];
